export default __webpack_public_path__ + "static/media/5.ca4f5869.jpg";